import { BrowserRouter as Router } from "react-router-dom";







import "./styles/App.scss";

import AppContainer from "./AppContainer";



const MainContent = () => {
  console.log(process.env);

  return (
    <Router>
   
        <AppContainer />

    </Router>
  );
};

function App() {
  return <MainContent />;
}

export default App;
